
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55.563 55.562","height":"210","width":"210"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M27.778 2.4C13.765 2.4 2.4 13.766 2.4 27.785c0 14.015 11.364 25.378 25.377 25.378 14.02 0 25.384-11.363 25.384-25.378 0-14.02-11.364-25.383-25.384-25.383zm0 1.569c13.154 0 23.816 10.662 23.816 23.815 0 13.149-10.662 23.81-23.816 23.81-13.148 0-23.81-10.661-23.81-23.81 0-13.153 10.662-23.815 23.81-23.815z","fill":"none","stroke":"#fdaf08","stroke-width":"3.9686999999999997","stroke-miterlimit":"10"}}),_c('path',{attrs:{"fill":"#fdaf08","fill-rule":"evenodd","d":"M24.604 12.868h6.35v20.108h-6.35zM24.604 36.68h6.35v6.085h-6.35z"}})])])
          )
        }
      }
    